"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlActiveTransactionsValidation = void 0;
const ChargingTransactionValidation_1 = require("./ChargingTransactionValidation");
class ChargerControlActiveTransactionsValidation {
    static isValid(entity) {
        // Validate entity.transactions for existence and correct type.
        if (entity.transactions == undefined)
            return false;
        if (!Array.isArray(entity.transactions))
            return false;
        if (!entity.transactions.every((elem) => {
            if (!ChargingTransactionValidation_1.ChargingTransactionValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.ChargerControlActiveTransactionsValidation = ChargerControlActiveTransactionsValidation;
